import { sendRequestGetLocal, sendRequestPostLocal } from "../backEnd/requesition"
import BlockNote from "../objects/BlockNote"

const _routerGetFromCloud = '/notes/getNotes'
const _routerAddNoteInCloud = '/notes/addNotes'
const _routerUpdateNote = '/notes/updateNotes'
const _routerRemoveNote = '/notes/removeNotes'

export const getNotes = async (showError) => {
    var results = []
    const blockList = []
    try {
        results = await sendRequestGetLocal(_routerGetFromCloud)
        
        if(Array.isArray(results)){
            Object.values(results).forEach(data =>{   
                var tempBlock = new BlockNote()
                tempBlock.fromCloud(data)
                blockList.push(tempBlock)
            })
        }else throw new Error(results.response.data.sqlMessage) 

    } catch (error) {
        showError('ERROR AO BUSCAR BLOCOS DE NOTAS',error.message)
    }finally{
        return blockList
    }
}


export const setUpdateBlockNote= async (blockNote,showError) =>{
    try {  

        let results = await sendRequestPostLocal(_routerUpdateNote,blockNote.getMapFromCloud([])) 
        if(results.status !== 200) throw new Error(results.response.data.sqlMessage)

        else return results
    
    } catch (error) {
        showError('ERROR AO ATUALIZAR NOTA',error.message)
        return {status:404}
    }
}

export const setNewBlockCode= async (blockNote,showError) =>{
    try {   
        var results = await sendRequestPostLocal(_routerAddNoteInCloud,blockNote.getMapFromCloud([]))
        if(results.status !== 200) throw new Error(results.response.data.sqlMessage)
        else return results
    } catch (error) {
        showError('ERROR AO ADICIONAR NOVA NOTA/PEDIDO',error.message)
        return {status:404}
    }
}

export const setBlockNoteRemove= async (blockNote,showError) =>{
    try {   
        var results = await sendRequestPostLocal(_routerRemoveNote,blockNote.getMapFromCloud([]))
        if(results.status !== 200) throw new Error(results.response.data.sqlMessage)
        else return results
    } catch (error) {
        showError('ERROR AO REMOVER NOTA',error.message)
        return {status:404}
    }
}